import { Api, ApiV2, Code } from '@.api';
import { PaginationType, UserResource } from '@.api/methods';
import { createDefaultPagination } from '@/Lib';

import { ClusterStoreModel } from '../model/ClusterStoreModel';
import { ClusterStoreListModel } from './ClusterStoreListModel';

export class ClusterStoreDetailService {
    private readonly DEFAULT_PER_PAGE = 10;

    async getClusterStores(
        spClusterId: number,
        page: number,
        searchStoreName: string
    ): Promise<{ stores: ClusterStoreListModel[]; pagination: PaginationType }> {
        const response = await ApiV2.serviceProviderClusters().listClusterStores(spClusterId, {
            page,
            q: searchStoreName,
            per_page: this.DEFAULT_PER_PAGE,
        });

        if (response.code === Code.Success) {
            return {
                stores: response.data.stores.items.map((store) => ({
                    storeId: store.id,
                    storeName: store.name,
                    companyName: store.company.name,
                    devicesCount: store.devices_count,
                    stationsCount: store.stations_count,
                })),
                pagination: response.data.stores.pagination,
            };
        }

        return {
            stores: [],
            pagination: createDefaultPagination(),
        };
    }

    async getClusterDetail(spClusterId: number): Promise<ClusterStoreModel> {
        const response = await ApiV2.serviceProviderClusters().getClusterDetail(spClusterId);

        if (response.code === Code.Success) {
            return {
                clusterId: response.data.sp_cluster.id,
                clusterName: response.data.sp_cluster.name,
                spUserId: response.data.sp_cluster.sp_user?.id || null,
            };
        }

        throw new Error('[ClusterStoreDetailService]: failed get cluster detail');
    }

    async getUserInfoForCluster(userId: number): Promise<UserResource> {
        const response = await Api.users().getById(userId);

        if (response.code === Code.Success) {
            return response.data;
        }

        throw new Error('[ClusterStoreDetailService]: failed get user info for cluster');
    }
}
